export const pages = {
	'signUp': { id: 'signUp', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'photobooth': { id: 'photobooth', page: 'quizPhotobooth', getter: () => import(/* webpackChunkName: 'quizPhotobooth' */ 'components/bolt/quizPhotobooth/quizPhotobooth') }
};
export const sections = [
	{ id: 'signUp', getter: () => import(/* webpackChunkName: "text" */ 'components/bolt/text/text'), component: 'text' }
];
export const sectionsWithParent = [

];
